// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Segment, Grid, Form, Header, Button, Dropdown, Menu, Icon } from 'semantic-grab-ui/src';
import formComponent from 'components/decorators/form_component';
import FormInputWithError from 'components/form/FormInputWithError';
import type { TridentCampaignDetails } from 'types/trident-campaigns';
import { allowedOperators } from 'data/trident-campaigns';
import _ from 'lodash';
import './TreatmentForm.scss';
import './WidgetComponent.scss';
import Toastr from 'utils/toastr-util';
import { StoreState } from 'omega-rtc/reducers';

type Props = {
  model: TridentCampaignDetails,
  canActivate: boolean,
  currentNode: string,
  parentNode: string,
  parentKeyList: Array<string>,
  onModelChange: (_?: Object) => void,
  handleInputChange: Function,
  handleControlBlur: Function,
  handleCloseModal: Function,
  isAdd: boolean,
  handleDeleteNode: Function,
  isValid: Function,
  error: any,
};

const DEFAULT_MAX_DELAY_MINS = 5760; // 4 days

@formComponent()
class DelayForm extends Component {
  props: Props;
  constructor(props: Props) {
    super(props);
    this.state = {
      originalModel: this.props.model,
      currentNode: this.props.currentNode,
      parentNode: this.props.parentNode,
    };
  }

  handleCreateCondition = (event: any, data: any) => {
    const newCondition = {
      lhs: data.value,
      operator: 'ge',
      rhs: 'delay',
    };
    const updatedModel = _.cloneDeep(this.props.model);
    const conditions = _.get(updatedModel.nodes[this.state.currentNode], 'data.condition.conditions', []);
    if (_.isEmpty(conditions)) {
      const condition = _.get(updatedModel.nodes[this.state.currentNode], 'data.condition', {});
      if (_.isEmpty(condition)) {
        _.set(updatedModel, `nodes.${this.state.currentNode}.data.condition`, newCondition);
      } else {
        conditions.push(condition);
        conditions.push(newCondition);
        const newConditionObject = {
          operator: 'AND',
          conditions,
        };
        _.set(updatedModel, `nodes.${this.state.currentNode}.data.condition`, newConditionObject);
      }
    } else {
      conditions.push(newCondition);
      _.set(updatedModel, `nodes.${this.state.currentNode}.data.condition.conditions`, conditions);
    }
    this.props.onModelChange(updatedModel);
  }

  handleConditionDelete = (event: any, data: any, index: number) => {
    const updatedModel = _.cloneDeep(this.props.model);
    const conditions = _.get(updatedModel.nodes[this.state.currentNode], 'data.condition.conditions', []);
    if (_.isEmpty(conditions)) {
      _.set(updatedModel, `nodes.${this.state.currentNode}.data.condition`, {});
    } else {
      conditions.splice(index, 1);
      if (conditions.length > 1) {
        _.set(updatedModel, `nodes.${this.state.currentNode}.data.condition.conditions`, conditions);
      } else {
        _.set(updatedModel, `nodes.${this.state.currentNode}.data.condition`, conditions[0]);
      }
    }
    this.props.onModelChange(updatedModel);
  }

  handleOperatorChange = (event: any, data: any, index: number) => {
    const updatedModel = _.cloneDeep(this.props.model);
    const conditions = _.get(updatedModel.nodes[this.state.currentNode], 'data.condition.conditions', []);
    if (_.isEmpty(conditions)) {
      _.set(updatedModel, `nodes.${this.state.currentNode}.data.condition.operator`, data.value);
    } else {
      conditions[index].operator = data.value;
      _.set(updatedModel, `nodes.${this.state.currentNode}.data.condition.conditions`, conditions);
    }
    this.props.onModelChange(updatedModel);
  }

  getAllTimeSinceOptions = function () {
    const timeSinceOptionList = [];
    _.map(this.props.model.nodes, (nodeData) => {
      if (nodeData.type === 'condition' || nodeData.type === 'scenarios') {
        if (_.get(nodeData, 'recordLastOccurrenceKey')) {
          timeSinceOptionList.push({ text: _.get(nodeData, 'recordLastOccurrenceKey'), value: 'timeSince:'.concat(_.get(nodeData, 'recordLastOccurrenceKey')) });
        }
      }
    });
    return timeSinceOptionList;
  }

  cancelDelay = () => {
    if (this.props.isAdd) {
      // eslint-disable-next-line no-alert
      const confirmValue = confirm('Cancel will delete this inactive node. Are you sure to delete this?');
      if (!confirmValue) return;
      this.props.handleDeleteNode(this.state.parentNode, this.state.currentNode, -1);
    } else {
      this.props.onModelChange(this.state.originalModel);
    }
    this.props.handleCloseModal();
  }

  saveDelay = () => {
    if (!this.props.isValid()) {
      Toastr.error('There are errors in delay form.');
      return;
    }

    const { model, featureFlagConfig } = this.props;
    const { currentNode } = this.state;
    const delayInMin = _.get(model.nodes[currentNode], 'data.durationInMin');
    const maxDelayInMin = _.get(featureFlagConfig, 'maxDelayInMins', DEFAULT_MAX_DELAY_MINS);
    if (delayInMin > maxDelayInMin) {
      Toastr.error(`You are not allowed to delay for more than ${maxDelayInMin} minutes`);
      return;
    }

    this.props.handleCloseModal();
  }

  render() {
    const gridStyle = {
      marginLeft: 40,
    };
    const { model } = this.props;
    const { currentNode } = this.state;

    const conditions = _.get(model.nodes[currentNode], 'data.condition.conditions', []);
    if (_.isEmpty(conditions)) {
      const data = _.get(model.nodes[currentNode], 'data.condition', {});
      if (!_.isEmpty(data)) {
        conditions.push(data);
      }
    }
    const timeSinceOptinons = this.getAllTimeSinceOptions();
    return (
      <div>
        <div className="model-button">
          <Grid>
            <Grid.Column textAlign="right">
              <Button.Group>
                <Button
                  onClick={this.cancelDelay}
                >
                  Cancel
                </Button>
                <Button.Or />
                <Button
                  positive
                  onClick={this.saveDelay}
                >
                  Save
                </Button>
              </Button.Group>
            </Grid.Column>
          </Grid>
        </div>
        <div className="treatment-form">
          <Segment className="treatment-form-segment">
            <Grid>
              <Grid.Column width={12}>
                <Header as="h3">Delay Name</Header>
              </Grid.Column>
            </Grid>
            <Grid>
              <Grid.Column width={12}>
                <Form>
                  <Grid>
                    <Grid.Column width={12}>
                      <FormInputWithError
                        name={'nodes.'.concat(`${currentNode}`, '.name')}
                        {...this.props}
                      >
                        <Form.Input
                          required
                          value={model.nodes[currentNode].name}
                          onChange={this.props.handleInputChange}
                          onBlur={this.props.handleControlBlur}
                        />
                      </FormInputWithError>
                    </Grid.Column>
                  </Grid>
                </Form>
              </Grid.Column>
            </Grid>
          </Segment>
          <Segment className="treatment-form-segment">
            <Grid>
              <Grid.Column width={12}>
                <Header as="h3">Condition</Header>
              </Grid.Column>
            </Grid>
            <Grid>
              <Grid.Column width={4} style={gridStyle}>
                <FormInputWithError
                  name={`nodes.${currentNode}.data.durationInMin`}
                  {...this.props}
                >
                  <Form.Input
                    label="Duration In Min"
                    type="number"
                    required
                    value={_.get(model.nodes[currentNode], 'data.durationInMin')}
                    onChange={this.props.handleInputChange}
                    onBlur={this.props.handleControlBlur}
                  />
                </FormInputWithError>
              </Grid.Column>
            </Grid>
            <Grid>
              <Grid.Column>
                <span>
                  {conditions.map((condition, index) => {
                    return (
                      <div key={condition.lhs} className="wrapDelayCondition">
                        <span>
                          <span className="wrapSpan">
                            {condition.lhs}
                          </span>
                          <span> {' '} </span>
                          <span>
                            <Dropdown
                              key={`dropDown_${index}`}
                              name="operator"
                              inline
                              options={allowedOperators}
                              value={condition.operator}
                              onChange={(event, data) => this.handleOperatorChange(event, data, index)}
                            />
                          </span>
                          <span> {' '} </span>
                          <span className="wrapSpan">
                            {_.get(model.nodes[currentNode], 'data.durationInMin')}
                          </span>
                          <span> {' '} </span>
                          <span>
                            <Icon key={`icon_${index}`} name="cancel" style={{ cursor: 'pointer', color: '#85C1E9', fontSize: '1em' }} onClick={(event, data) => this.handleConditionDelete(event, data, index)} />
                          </span>
                        </span>
                      </div>
                    );
                  })}
                  {!_.isEmpty(timeSinceOptinons) &&
                  <span>
                    <span> {' '} </span>
                    <Menu compact>
                      <Dropdown
                        name="timeSince"
                        text="AND"
                        simple
                        item
                      >
                        <Dropdown.Menu className="left" style={{ maxHeight: 'auto' }}>
                          {timeSinceOptinons.map((item) => (
                            <Dropdown.Item key={item.value} value={item.value} onClick={this.handleCreateCondition}>{item.text}</Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </Menu>
                  </span>
                  }
                </span>
              </Grid.Column>
            </Grid>
          </Segment>
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state: StoreState) {
  return {
    featureFlagConfig: _.get(state, 'newTridents.featureFlagConfig', {}),
  };
}

export default connect(mapStateToProps, {})(DelayForm);
